import { useEffect, useState } from 'react';
import styles from './Hero.module.css';
import imgEgo from '../../assets/images/heros/1_ego.webp';
import imgAbility from '../../assets/images/heros/2_ability.webp';
import imgNightcall from '../../assets/images/heros/3_nightcall.webp';
import imgUrgent from '../../assets/images/heros/4_urgent.webp';

// 4 슬롯 헤드라인 — 정체성 / 능력 / 접수 가용성 / 응답 속도 네 각도로 임팩트 회전.
// 의료인의 진료 시간·다급함을 이해 → 우리만의 서비스 약속(밤 9시 접수, 24시간 응답)
// 으로 맞춤형 변호사라는 인상을 즉시 전달.
const HEADLINES = [
  // 정체성 — 의사의 마음을 이해하는 변호사 (의사 출신을 버리지 않은 정체성)
  { lead: '의사의 마음을 온전히 이해하는,', hi: '단 하나의 법률 파트너.' },
  // 능력 (EMR)
  { lead: 'EMR을 읽는 변호사,', hi: '변론의 깊이가 다릅니다.' },
  // 접수 가용성 — 의료인의 진료 시간을 이해
  { lead: '의료인의 진료 시간을 이해하기에,', hi: '밤 9시까지 문의를 받습니다.' },
  // 응답 속도 — 의료인의 다급함을 이해
  { lead: '의료인의 다급함을 이해하기에,', hi: '24시간 안에 응답합니다.' },
];

// 4 모서리 시나리오 — 각 헤드라인 슬롯의 가치 어필 카드. 큰 카드 두 장(topLeft,
// bottomRight)이 핵심 차별점(정체성·능력), 작은 카드 두 장이 서비스 약속(접수·응답).
const SCENARIOS = [
  { src: imgEgo, label: '의사 출신 변호사', pos: 'topLeft' },
  { src: imgNightcall, label: '밤 9시까지 접수', pos: 'topRight' },
  { src: imgUrgent, label: '24시간 안 응답', pos: 'bottomLeft' },
  { src: imgAbility, label: 'EMR 직독 분석', pos: 'bottomRight' },
];

const ROTATE_INTERVAL = 4200;

export function Hero() {
  const [idx, setIdx] = useState(0);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const t = setInterval(() => {
      setIdx((i) => (i + 1) % HEADLINES.length);
    }, ROTATE_INTERVAL);
    return () => clearInterval(t);
  }, []);

  // 코너 시나리오 애니메이션은 splash 화면이 사라진 후 시작.
  // splash 가 이미 없으면 (세션 재진입 / SPA 내부 네비) 다음 paint 직후 시작.
  useEffect(() => {
    if (!document.getElementById('splash')) {
      const r = requestAnimationFrame(() => setStarted(true));
      return () => cancelAnimationFrame(r);
    }
    const onDismiss = () => setStarted(true);
    window.addEventListener('splash:dismissed', onDismiss);
    // 안전망: 6초 안에 이벤트가 안 오면 강제로 시작
    const fallback = setTimeout(() => setStarted(true), 6000);
    return () => {
      window.removeEventListener('splash:dismissed', onDismiss);
      clearTimeout(fallback);
    };
  }, []);

  return (
    <section className={styles.hero} id="top">
      {SCENARIOS.map((s, i) => (
        <figure
          key={s.label}
          className={`${styles.scene} ${styles[`scene_${s.pos}`]} ${started ? styles.sceneRun : ''}`}
          style={started ? { animationDelay: `${i * 0.18}s` } : undefined}
          aria-label={s.label}
        >
          <img src={s.src} alt={s.label} className={styles.sceneImg} />
          <figcaption className={styles.sceneLabel}>{s.label}</figcaption>
        </figure>
      ))}

      <div className={styles.inner}>
        <div className={styles.badge}>법무법인 오킴스 의료팀 공식 서비스</div>

        <h1 className={styles.titleWrap}>
          {HEADLINES.map((h, i) => (
            <span
              key={i}
              className={`${styles.title} ${i === idx ? styles.titleActive : ''}`}
              aria-hidden={i !== idx}
            >
              {h.lead}
              <br />
              <span className={styles.hi}>{h.hi}</span>
            </span>
          ))}
        </h1>

        <p className={styles.sub}>
          일반 변호사가 의료감정인 해석에 기댈 때,
          <br />
          저희는 차트·영상·처방 기록을 <strong className={styles.subEm}>의사의 눈</strong> 으로 직접
          분석합니다.
          <br />
          무엇이 부당한 책임이고 무엇이 정당한 진료인지 — 가장 잘 아는 변호사.
        </p>

        <a href="#inquiry" className={styles.cta}>
          지금 상담 신청하기
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path
              d="M3 8h10M9 4l4 4-4 4"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </a>

        <div className={styles.tags}>
          <span className={styles.tag}>진료 시간 보호</span>
          <span className={styles.tag}>24시간 온라인 대응</span>
          <span className={styles.tag}>의사·치과의사 출신 변호사</span>
          <span className={styles.tag}>법무법인 오킴스 직속</span>
        </div>
      </div>

      <div className={styles.bottomRule} />
    </section>
  );
}
